import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";

function ProfileImage(props) {
  const pStyle = {
    border: "2px solid #fff",
    borderRadius: "50%",
    textAlign: "center",
    height: "50px",
    width: "50px",
    fontSize: "40px",
    backgroundColor: props.backgroundColor,
    color: props.color,
    margin: "auto",
    overflow: "hidden",
  };
  if (props.isActive) {
    pStyle.border = "2px solid #040d41";
  }
  const labelS = {
    textAlign: "center",
    color: "#040d41",
    fontWeight: "bold",
    fontSize: "1vw",
    padding: "1px",
  };

  return (
    <div
      onClick={() => {
        props.SetProfile(props.prof);
      }}>
      <div className="ProfileLabel" style={labelS}>
        {props.isActive ? "Current" : ""}
      </div>
      <div style={pStyle}>
        <FontAwesomeIcon icon={faUser} />
      </div>
      <div className="ProfileLabel" style={labelS}>
        {props.children}
      </div>
    </div>
  );
}

export default ProfileImage;
